'use client';

import { Box, Image, Flex, For, Link, Button, useBreakpointValue, Heading } from "@chakra-ui/react";
import { useState, useEffect } from "react";
import ShadowBox from "@/components/partials/ShadowBox";
import useEmblaCarousel from 'embla-carousel-react';
import Autoplay from 'embla-carousel-autoplay'
import { Fancybox } from '@fancyapps/ui'
import '@fancyapps/ui/dist/fancybox/fancybox.css'


export default function Gallery({ data }) {
  const gallery = data.map((item) => {
    if(!item?.attachFiles || item?.attachFiles.length === 0) {
      return null;
    }

    const box = item.attachFiles.find(f => f.mediaTyped === 'box')?.mediaCdnUrl || null;
    const otimized = item.attachFiles.find(f => f.mediaTyped === 'otimized')?.mediaCdnUrl || null;
    if(!box || !otimized) {
      return null;
    }

    return {
      imageName: item?.attachTitle || 'Imagem da Galeria',
      imageThumb: box,
      imageFull: otimized,
    }
  }).filter(i => i !== null);

  const slidesToShow = useBreakpointValue({ base: 1, sm: 2, lg: 4 });
  const [emblaRef, emblaApi] = useEmblaCarousel({
    loop: true,
    align: 'start',
    slidesToScroll: slidesToShow,
  }, [Autoplay({ delay: 3000 })]);

  useEffect(() => {
    if (emblaApi) emblaApi.reInit();
  }, [slidesToShow, emblaApi]);

   const [selectedIndex, setSelectedIndex] = useState(0);

   useEffect(() => {
    if (!emblaApi) return;

    const onSelect = () => {
      setSelectedIndex(emblaApi.selectedScrollSnap());
    };

    emblaApi.on('select', onSelect);
    return () => emblaApi.off('select', onSelect);
  }, [emblaApi]);

  const totalSlides = Math.ceil(gallery.length / slidesToShow);

   useEffect(() => {
    Fancybox.bind('[data-fancybox]', {
      Toolbar: {
        display: {
          left: [],
          middle: [],
          right: ['close']
        }
      }
    })

    return () => {
      Fancybox.unbind('[data-fancybox]')
      Fancybox.close()
    }
  }, [])


  return (
    <ShadowBox padding="8">
      <Heading as="h4" fontFamily="inherit" fontWeight="700" fontSize="2em" pb="4" ineHeight="1" color="blue.500">
        Galeria de Imagens:
      </Heading>

      <Box className="embla" ref={emblaRef} overflow="hidden">
          <Flex justifyContent="space-between" pb={{ base: '12', lg: '0' }} className="embla__container">
              { gallery.map((item, key) => (
                <Box
                  key={key}
                  color="white"
                  style={{
                    flex: `0 0 ${(100 / slidesToShow) - 2}%`,
                  }}
                  textAlign="center"
                  mx="4"
                  py="8"
                  className="embla__slide"
                >
                  <Link href={item.imageFull} target="_blank" data-fancybox="gallery" data-caption={item.imageName}>
                    <Image
                      src={item.imageThumb}
                      alt={item.imageName}
                      w="100%"
                      h="100%"
                      objectFit="cover"
                    />
                  </Link>
                </Box>
              ))}
          </Flex>
      </Box>

      <Flex justify="center" mt={4} gap={2}>
        { Array.from({ length: totalSlides }).map((_, index) => (
          <Button
            key={index}
            size="xs"
            w="12px"
            h="12px"
            p={0}
            border="1px solid"
            borderColor="gray.300"
            borderRadius="full"
            bg={selectedIndex === index ? 'gray.300' : 'none'}
            _hover={{ bg: 'gray.500' }}
            onClick={() => emblaApi?.scrollTo(index)}
            aria-label={`Ir para slide ${index + 1}`}
          />
        ))}
      </Flex>
    </ShadowBox>
  )
}
